module.exports = __webpack_public_path__ + "img/3-10.63b5c149.png";